// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"e52d4744","400":"64f7acb6","458":"7e54b6b8","492":"58134135","639":"8b267c67","934":"08566781"}[chunkId] + ".chunk.js";
};